/**
 * @module Section-Shared-About-Content
 */

import { NavLink, useNavigate } from "react-router-dom";
import { navUrl } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionAbout } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";

/**
 * 
 * @param props : Data supplied to display About Us
 * @returns Wrapper element for about us content
 */
const SectionSharedAbout = (
    props: {
        _about: TypeSectionAbout
    }
) => {
    return (
        <div className="section-full p-t120 p-b90 site-bg-white av-about-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2">
            <div className="section-content">
                <div className="container">
                    <SectionSharedAboutContent _about={props._about} />
                </div>
            </div>
        </div>
    )
}

/**
 * 
 * @param props : Data supplied to hold about us content
 * @returns Markup for about us content
 */
export const SectionSharedAboutContent = (
    props: {
        _about: TypeSectionAbout
    }
) => {
    const { _about } = props;
    const navigate = useNavigate();

    const handleDiscoverMore = (e: React.MouseEvent) => {
        e.preventDefault();
        const currentPath = window.location.pathname;
        
        if (currentPath !== '/') {
            navigate('/#services');
        } else {
            const $services = (window as any).$ ? (window as any).$('#services') : null;
            if ($services && $services.length) {
                (window as any).$('html, body').stop().animate({
                    scrollTop: $services.offset().top
                }, {
                    duration: 1000,
                    complete: function() {
                        if (window.location.hash === '#services') {
                            window.history.replaceState(null, '', window.location.pathname + window.location.search);
                        }
                        (window as any).$('html, body').css({ overflow: '', height: '' });
                    }
                });
            }
        }
    };

    return (
        <>
        <div className="row">
            <div className="col-lg-6 col-md-12 m-b30">
                <div className="av-about-media-section">
                    <div className="av-ver-text">
                        <span>{_about.experience}</span>
                    </div>
                    <div className="av-large-image">
                        <AvertImage src={_about.image} alt="Anathoth Technologies team - Leading IT consulting and software development experts in Uganda" />
                    </div>
                    <div className="av-ab-dot-left">
                        <AvertImage src="images/ab-dotts.png" alt="Decorative pattern background" />
                    </div>
                    <div className="av-ab-dot-right">
                        <AvertImage src="images/ab-dotts.png" alt="Decorative pattern background" />
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-md-12 m-b30">
                <div className="av-about-content-section">
                    <div className="av-content-title">
                        <h2 className="av-large-title">{_about.title}</h2>
                        <div dangerouslySetInnerHTML={
                            { __html: _about.description }
                        }></div>
                    </div>
                        <div className="av-about-readmore">
                            <button onClick={handleDiscoverMore} className="site-button">
                                Discover More
                                <i className="fa fa-plus" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );
}

export default SectionSharedAbout;